import classNames from 'classnames/bind';
import commaNumber from 'comma-number';
import React, { useMemo } from 'react';

import styles from './CellGroup.module.scss';

import { Cell } from '@/components/ui/dashboard/Monitor';
import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';
import dayjs from '@/libs/dayjs';

const cx = classNames.bind(styles);

const CellGroup = ({ robotId }) => {
  const batteryStatus = useRobotTelemetry(robotId, MESSAGE.BATTERY_STATUS);

  const { battery, voltage, endurance } = useMemo(() => {
    return {
      battery: !batteryStatus || batteryStatus.batteryRemaining === -1 ? 'Not Est.' : batteryStatus.batteryRemaining,
      voltage: (batteryStatus?.voltages[0] ?? 0) / 1000,
      endurance:
        !batteryStatus || batteryStatus.timeRemaining === 0
          ? 'Not Est.'
          : dayjs.duration(batteryStatus.timeRemaining, 'seconds').format('HH:mm:ss'),
    };
  }, [batteryStatus]);

  return (
    <div className={cx('container')}>
      <Cell data={[{ title: 'Battery', value: battery, unit: typeof battery === 'number' ? '%' : undefined }]} />
      <Cell data={[{ title: 'Voltage', value: commaNumber(voltage.toFixed(1)), unit: 'v' }]} />
      <Cell data={[{ title: 'Endurance', value: endurance }]} />
    </div>
  );
};

export default CellGroup;
